import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ZAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { getScreenTime, requestList } from "../../../AxiosRtk/DashBoard";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { isEmpty } from "lodash";
import { useHistory } from "react-router";
import { setShowInfo } from "../../../AxiosRtk/successMessage";

export const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          background: "white",
          zIndex: 10,
          width: "250px",
          height: "200px",
          padding: "20px",
        }}
      >
        <p className="label">{`Hour: ${label}`}</p>
        {payload?.map((dataPoint, index) => (
          <p key={index} className={`value-${index}`}>
            {`${dataPoint.name}: ${dataPoint.value} min`}
          </p>
        ))}
      </div>
    );
  }

  return null;
};

const ScreenTime = ({ getLangTranslation }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(true);
  const { selectedKidId, kidList, selectedDeviceData } = useSelector(
    ({ dashboard }) => dashboard
  );
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);

  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  const [graphData, setGraphData] = useState([]);
  const [bars, setBars] = useState([]);
  const [barGraphData, setBarGraphData] = useState([]);
  const [screenTimeData, setScreenTimeData] = useState({
    totalAllocated: 0,
    totalUsedTime: 0,
  });

  const beginTime = moment().locale("en").format("YYYY-MM-DD 00:00:00");
  const endTime = moment().locale("en").format("YYYY-MM-DD HH:mm:ss");
  useEffect(() => {
    getScreenTime()
      .then((res) => {
        setGraphData(res?.data?.result?.graphData);
        setScreenTimeData({
          totalAllocated: res?.data?.result?.totalAllocated,
          totalUsedTime: res?.data?.result?.totalUsedTime,
        });
      })
      .catch((err) => {
        console.log(
          "web activity catch error ==>>",
          err?.response?.data?.message
        );
      });
  }, []);

  useEffect(() => {
    if (!isEmpty(graphData)) {
      const barMap = new Map();
      const graphBarMap = new Map();

      graphData.forEach((item) => {
        if (item?.category && item?.color && !barMap.has(item?.category)) {
          barMap.set(item?.category, item?.color);
        }
        if (graphBarMap.has(Number(item?.hour))) {
          const categoryObj = { ...graphBarMap.get(Number(item?.hour)) };
          if (categoryObj[item?.category?.split(" ")[0]]) {
            categoryObj[item?.category?.split(" ")[0]] =
              +categoryObj[item?.category?.split(" ")[0]] + +item?.duration;
          } else {
            categoryObj[item?.category?.split(" ")[0]] = item?.duration;
          }
          graphBarMap.set(Number(item?.hour), categoryObj);
        } else {
          const tempObj = {
            name: Number(item?.hour),
            [item?.category?.split(" ")[0]]: item?.duration,
          };
          graphBarMap.set(Number(item?.hour), { ...tempObj });
        }
      });
      const dataBarMap = Array.from(barMap, ([key, value]) => ({
        dataKey: key,
        fill: value,
      }));
      setBars(dataBarMap);

      const graphBarMapData = Array.from(graphBarMap, ([key, value]) => value);
      setBarGraphData(graphBarMapData);
    }
  }, [graphData]);

  useEffect(() => {
    const payload = {
      kidId: selectedKidId,
      device_id: selectedDeviceData?.ID,
      startDate: beginTime,
      endDate: endTime,
      day: "dummy",
    };

    if (selectedDeviceData && selectedKidId) {
      requestList(payload)
        .then((res) => { })
        .catch((err) => {
          console.log(
            "request list catch error  ==>>",
            err?.response?.data?.message
          );
        });
    }
  }, [selectedKidId, selectedDeviceData]);

  // Sample data
  const data = [
    { name: "SUN", value1: 50 },
    { name: "MON", value1: 50 },
    { name: "TUE", value1: 50 },
    { name: "WED", value1: 50 },
    { name: "THU", value1: 50 },
    { name: "FRI", value1: 50 },
    { name: "SAT", value1: 50 },
  ];

  function timeConverter(min) {
    if (!min && min !== 0) return 0; // Handle edge cases like undefined or null

    let hours = Math.floor(min / 60);           // Get the hours
    let minutes = Math.floor(min % 60);        // Get the remaining minutes
    let seconds = Math.floor((min - Math.floor(min)) * 60); // Convert fractional minutes to seconds

    // Add leading zero to single-digit minutes and seconds
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return `${hours}h ${minutes}m ${seconds}s`;
  }

  function timeConverterSeconds(sec) {
    if (!sec && sec !== 0) return "0h 00m 00s"; // Handle edge case if input is undefined or null

    let hours = Math.floor(sec / 3600);           // Get the hours (1 hour = 3600 seconds)
    let minutes = Math.floor((sec % 3600) / 60);  // Get the remaining minutes
    let seconds = sec % 60;                      // Get the remaining seconds

    // Add leading zero to single-digit minutes and seconds
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return `${hours}h ${minutes}m ${seconds}s`;
  }

  function getDurationPercentage(usedTime, totalTime) {
    if (usedTime && totalTime) {
      return Math.floor((usedTime * 100) / totalTime);
    }
  }

  const isDevicesAvailable = kidList && selectedKidId
    ? kidList.find(kid => kid?.ID === selectedKidId)?.KidsDevices?.[0]?.Name
    : null;

  useEffect(() => {
    // Disable the button if no device is available
    if (!isDevicesAvailable) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [isDevicesAvailable]);

  const handleScreenClick = (event) => {
    // If no device is selected, show an error message and prevent navigation
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select device",
        })
      );
      return; // Stop further action if device is not selected
    }

    // Proceed to the /keyword-stats page if a device is selected
    if (!isDisabled) {
      history.push("/screen-time");
    }
  };

  if (kidList?.length > 0) {
    return (
      <div className="col-md-6">
        <div className="card h-100">
          <div
            className="card-header d-flex justify-content-between align-items-center c-pointer"
            onClick={handleScreenClick}
          >
            <h3 className="card-title mb-0">
              {getLangTranslation(
                "PARENT_DASHBOARD_FAMILY_SCREEN_TIME",
                "Family Screen Time"
              )}
            </h3>
            <i
              className={`cursor-pointer fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
                }`}
              aria-hidden="true"
            ></i>
          </div>
          <div className="card-body">
            {isDevicesAvailable && !isEmpty(graphData) ? (
              <div className="graph">
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart width={1000} height={500} data={barGraphData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    {/* Ensure XAxis is inside the BarChart component */}
                    <XAxis dataKey="name" label={{ value: getLangTranslation("PARENT_DASHBOARD_HOURS", "Hours"), position: "insideBottom", offset: -5 }} />

                    {/* YAxis with label */}
                    <YAxis label={{ value: getLangTranslation("PARENT_DASHBOARD_GRAPH_FAMILY_SCREEN_X_AXIS_APP_USED_TIME", "App Used time"), angle: -90, position: "insideLeft" }} />
                    <Tooltip />
                    <Legend />
                    {bars.map((item) => (
                      <Bar
                        dataKey={item.dataKey.split(" ")[0]}
                        stackId="a"
                        fill={item.fill}
                        key={item.fill}
                      />
                    ))}
                  </BarChart>
                </ResponsiveContainer>
              </div>
            ) : (
              <div className="text-center my-3">
                --{" "}
                {getLangTranslation(
                  "PARENT_TASK_DATA_NOT_FOUND",
                  "No data found !"
                )}{" "}
                --
              </div>
            )}
            {isDevicesAvailable && (
              <>
                <span className="text-dark fw-bold">
                  {getLangTranslation("CHILD_LOCATION_TODAY", "Today")}
                </span>
                <div className="my-3">
                  <div className="d-flex justify-content-between">
                    <span>
                      {timeConverterSeconds(Math.abs(screenTimeData?.totalUsedTime))}
                    </span>
                    <span>
                      {timeConverter(Math.abs(screenTimeData?.totalAllocated))}
                    </span>
                  </div>


                  <div
                    className="progress mt-1"
                    role="progressbar"
                    aria-label="Basic example"
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    <div
                      className="progress-bar"
                      style={{
                        width: `${getDurationPercentage(
                          screenTimeData?.totalUsedTime,
                          screenTimeData?.totalAllocated
                        )}%`,
                      }}
                    ></div>
                  </div>

                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="col-md-6">
        <div className="card h-100">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0 text-gray">
              {getLangTranslation(
                "PARENT_DASHBOARD_FAMILY_SCREEN_TIME",
                "Family screen time"
              )}
              <i
                className={`cursor-pointer fa ${lang?.isRTL === 1 ? "fa-angle-left" : "fa-angle-right"
                  }`}
                aria-hidden="true"
                onClick={handleScreenClick}
              ></i>
            </h5>
            <p className="text-dark mt-4 mb-1 fw-700 fs-7">
              {getLangTranslation(
                "PARENT_DASHBOARD_HERE_WILL_SHOW_SCREEN_TIME",
                "Here will show Screen Time"
              )}
            </p>
            <p className="text-dard fs-8 mt-0">
              {getLangTranslation(
                "PARENT_DASHBOARD_FIRST_ADD_CHILD",
                "But first add your child and the device they are using!"
              )}
            </p>
          </div>

          <div className="card-body">
            <ResponsiveContainer width="100%" height={500}>
              <BarChart width={450} height={500} data={data}>
                <CartesianGrid />
                <XAxis dataKey="name" />
                <YAxis />
                <ZAxis />
                <Tooltip content={<CustomTooltip />} />
                <Bar dataKey="x" stackId="a" fill="#e6f9ff" />
                <Bar dataKey="y" stackId="a" fill="#66B5FF" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    );
  }
};

export default ScreenTime;
